var gql = require("@apollo/client").gql;

const SITE_CONFIG_QUERY = gql`
	query SiteConfig {
		siteConfig {
			code
			name
			logo
			logo_2
			logo_3
			logo_4
			static_location
			domain_name
			domain_name_full
			order_counter
			social_network_image
			ssl
			email
			regions {
				available {
					id
					name
					url
					is_capital
					image_xs
					image_sm
					image_md
					image_lg
					is_show_qwiz
					info_popup
					position
				}
				default {
					id
					name
					url
					is_capital
					image_xs
					image_sm
					image_md
					image_lg
					is_show_qwiz
				}
			}
			social_our_groups {
				code
				url_group
			}
			contacts {
				shema_proezda
				passage
				office_address
				post_address
				additional_contacts
				additional_address
				contact_phone
				email_for_partners
			}
			settings {
				show_closing_cross_tc {
					time_start
					time_end
					enabled
				}
				floating_phone {
					time_start
					time_end
					enabled
				}
				mobile_popup {
					time_start
					time_end
					enabled
				}
				mobile_tariffs_mode
				show_new_view_search
				autosearch_address_not_success
				show_quiz_with_direct_transition
				one_string_search {
					enabled
				}
				exit_popup {
					enabled
					hold_title
					hold_text
					hold_logo
				}
				vpn_popup {
					time_start
					time_end
					enabled
				}
				info_popup {
					enabled
					bg_color
					text_color
					body_text
					time_start_mon
					time_end_mon
					time_start_tue
					time_end_tue
					time_start_wed
					time_end_wed
					time_start_thu
					time_end_thu
					time_start_fri
					time_end_fri
					time_start_sat
					time_end_sat
					time_start_sun
					time_end_sun
				}
				connect_tariff_button {
					provider_card
					main
					tc
					rating
					action_prov
					action_detail
					catalog_prov
					tariffs_tags_region
					about_prov
					tariffs_prov
					tariffs_tags_prov
					exclusives
					action_region
				}
				recently_connect_tariff_button {
					search_address
					no_vip_card
					no_vip_rating
				}
				order_after {
					title_1
					text_1
					title_2
					text_2
					button_text
					button_url
				}
				whatsapp_send_message {
					rates_house_id {
						id
						name
						enabled
						text
					}
					feedback {
						id
						name
						enabled
						text
					}
					otzyv_id {
						id
						name
						enabled
						text
					}
					reviews {
						id
						name
						enabled
						text
					}
					rating {
						id
						name
						enabled
						text
					}
					contack_feedback {
						id
						name
						enabled
						text
					}
					actions {
						id
						name
						enabled
						text
					}
					actions_id {
						id
						name
						enabled
						text
					}
					exclusive {
						id
						name
						enabled
						text
					}
					address {
						id
						name
						enabled
						text
					}
					page_404 {
						id
						name
						enabled
						text
					}
					fixed_navigation {
						id
						name
						enabled
						text
					}
					fixed_navigation_operatory {
						id
						name
						enabled
						text
					}
					connect_tariff {
						id
						name
						enabled
						text
					}
					pup_up_operator {
						id
						name
						enabled
						text
					}
					installers {
						id
						name
						enabled
						text
					}
				}
				telegram_send_message {
					installers {
						id
						name
						enabled
						text
					}
				}
				connect_action
				yandex_captcha
				widget_yandex_reviews
				banner101rubles
				frame_esim_mts
				animation_frontend {
					search_address_header
					whatsapp_header
					phone_button_header
				}
				form_orders_one_click {
					main {
						type
						enabled
						background
						text_button
						text_button_color
						button_color
						heading_text
						main_text
						image
					}
					TC {
						type
						enabled
						background
						text_button
						text_button_color
						button_color
						heading_text
						main_text
						image
					}
					reviews {
						type
						enabled
						background
						text_button
						text_button_color
						button_color
						heading_text
						main_text
						image
					}
					tohome {
						type
						enabled
						background
						text_button
						text_button_color
						button_color
						heading_text
						main_text
						image
					}
					exclusive {
						type
						enabled
						background
						text_button
						text_button_color
						button_color
						heading_text
						main_text
						image
					}
					catalog {
						type
						enabled
						background
						text_button
						text_button_color
						button_color
						heading_text
						main_text
						image
					}
					rating {
						type
						enabled
						background
						text_button
						text_button_color
						button_color
						heading_text
						main_text
						image
					}
					from_popular_house {
						type
						enabled
						background
						text_button
						text_button_color
						button_color
						heading_text
						main_text
						image
					}
				}
			}
			experiments {
				name
				variants {
					name
					weight
					use_default_react
				}
			}
		}
	}
`;

module.exports = SITE_CONFIG_QUERY;
